/*
 * This script nests objects
 *
 * The backend currently returns data like this:
 *
 * {
 *   "creditor.address.lines": { myField },
 *   "creditor.birthdate": { anotherField }
 * }
 *
 * This script converts it to:
 *
 * {
 *   "creditor": {
 *     "address": {
 *       "lines": { myField }
 *     },
 *     "birthdate": { anotherField }
 *   }
 * }
 *
 *
 * The reason that we need this, is that the FE wants to be able to fold them,
 * and it's much easier with the second structure than the first.
 *
 */
export function extractNestedFields(fields: any[] | undefined) {
  if (!fields) {
    return [];
  }

  const result: any[] = [];

  fields.forEach((field) => {
    // Check if the field contains a dot (indicating nesting)
    if (field.field.includes('.')) {
      const [parentField, childField] = field.field.split('.');

      // Check if the parent field already exists in the result
      const parent = result.find((item) => item.field === parentField);

      // If the parent field doesn't exist, add it to the result
      if (!parent) {
        result.push({
          field: parentField,
          type: 'Object',
          fields: [
            {
              field: childField,
              description: field.description,
              type: field.type,
              rules: field.rules
            }
          ]
        });
      } else {
        // If the parent field already exists, add the child field to its fields array
        parent.fields.push({
          field: childField,
          description: field.description,
          type: field.type,
          rules: field.rules
        });
      }
    } else {
      // If the field doesn't contain a dot, add it directly to the result
      result.push({
        field: field.field,
        description: field.description,
        type: field.type,
        rules: field.rules
      });
    }
  });

  return result;
}
